// extracted by mini-css-extract-plugin
export default {"element":"EmbedVimeo-module--element--711b4"};